import { endpoint } from "../../utils/endpoint";
import { IQuoteTemplateInput } from "../../types/IQuoteTemplate";
import {
  axiosGet, axiosPost, axiosPut, axiosDelete,
} from "../axiosRequests";

const QUOTE_TEMPLATE_FIELDS_ENDPOINT = (templateId: number): string => endpoint(`app/v1.0/quote_templates/${templateId}/quote_template_fields`);

function formatSignatureInputPayload(input: { attributes: Partial<IQuoteTemplateInput["attributes"]> }): object {
  if (!input?.attributes) return {};

  const {
    customField,
    id,
    inputType,
    name,
    required,
    signer,
    templateId,
  } = input.attributes;

  return {
    quote_template_field: {
      name,
      input_type: inputType,
      custom_field: customField,
      signer,
      quote_template_id: templateId,
      id,
      required,
    },
  };
}

export async function fetchSignatureInputs(templateId: number): Promise<IQuoteTemplateInput[]> {
  const response = await axiosGet(QUOTE_TEMPLATE_FIELDS_ENDPOINT(templateId));
  return response.data.data || [];
}

export async function createSignatureInput(
  templateId: number,
  payload: { attributes: Partial<IQuoteTemplateInput["attributes"]> },
): Promise<IQuoteTemplateInput> {
  const formattedPayload = formatSignatureInputPayload(payload);
  const response = await axiosPost(QUOTE_TEMPLATE_FIELDS_ENDPOINT(templateId), formattedPayload);
  return response.data.data;
}

export async function updateSignatureInput(
  templateId: number,
  fieldId: string,
  payload: { attributes: Partial<IQuoteTemplateInput["attributes"]> },
): Promise<IQuoteTemplateInput> {
  const url = `${QUOTE_TEMPLATE_FIELDS_ENDPOINT(templateId)}/${fieldId}`;
  const formattedPayload = formatSignatureInputPayload(payload);
  const response = await axiosPut(url, formattedPayload);
  return response.data.data;
}

export async function deleteSignatureInput(templateId: number, fieldId: string): Promise<void> {
  const url = `${QUOTE_TEMPLATE_FIELDS_ENDPOINT(templateId)}/${fieldId}`;
  await axiosDelete(url);
}
